import React, { useState, useCallback, useEffect } from 'react';
import PieChart, {
  Legend as PCLegend,
  Series as PCSeries,
  Tooltip as PCTooltip,
  Label,
  Connector,
} from 'devextreme-react/pie-chart';
import { groupBy } from '../../utils/miscUtil';
import { TagBox } from 'devextreme-react/tag-box';
import { SelectBox } from 'devextreme-react/select-box';

const palette = ["rgba(20, 77, 109, 1)", "rgba(236, 80, 32, 1)", "rgba(92, 194, 215, 1)", "rgba(0, 162, 200, 1)", "rgba(20, 77, 109, 0.4)", "rgba(236, 80, 32, 0.4)", "rgba(92, 194, 215, 0.4)", "rgba(0, 162, 200, 0.4)"]

export default function ESGQualitativeMetrics(props) {
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [selectedYear, setSelectedYear] = useState([]);
  const [workhoursData, setWorkhoursData] = useState([]);
  const [waterData, setWaterData] = useState([]);

  useEffect(() => {
    setSelectedYear(parseInt(props.year)-1);
  }, [props.year]);

  useEffect(() => {
    var fd = [];
    var fd1 = [];
    var i = 0;

    fd1 = groupBy(props.data, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())

    var originalData = props.data
    if (selectedCompaniesList.length) {
      originalData = originalData.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }

    fd = originalData.filter((e) => {return e["Identifier"] === "32" && e["year"] ===selectedYear.toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setWorkhoursData(fd);

    fd = originalData.filter((e) => {return e["Identifier"] === "15" && e["year"] ===selectedYear.toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setWaterData(fd);

  }, [props.data, selectedYear, selectedCompaniesList]);

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText}: ${pointInfo.valueText}</div><div class="tooltip-body">${pointInfo.point.data.companies.join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  const onYearChanged = useCallback((e) => {
    setSelectedYear(e.value);
  }, [setSelectedYear])

  return (
    <>
    <h4>Qualitative Metrics Strategies in {parseInt(props.year)-1} </h4>
    <div className="d-flex flex-row">
      <TagBox
          dataSource={allCompaniesList}
          value={selectedCompaniesList}
          showDropDownButton={true}
          width="100%"
          activeStateEnabled={true}
          multiline={false}
          showSelectionControls={true}
          onValueChanged={onCompaniesChanged}
          label={"Company"}
          labelMode="floating"
          placeholder={"Select Companies"}
      />
      <div className="mx-1"/>
      <SelectBox
          dataSource={[parseInt(props.year)-1, parseInt(props.year)-2, parseInt(props.year)-3]}
          value={selectedYear}
          width="250px"
          showDropDownButton={true}
          activeStateEnabled={true}
          onValueChanged={onYearChanged}
          label={"Year"}
          labelMode="floating"
          placeholder={"Year"}
      />
    </div>
    <hr className={'mb-4'}/>
    <div className="d-flex flex-column justify-content-between">
      <h5>Workhours Calculation Methodology</h5>
      <div className="d-flex flex-row w-100 justify-content-center">
        <PieChart
          id="pie"
          type="doughnut"
          palette={palette}
          dataSource={workhoursData}
          resolveLabelOverlapping={"shift"}
        >
          <PCSeries argumentField="name">
            <Label visible={true}>
              <Connector visible={true} />
            </Label>
          </PCSeries>
          <PCLegend rowCount={2} margin={0} horizontalAlignment="center" verticalAlignment="bottom" />
          <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
          </PCTooltip>
        </PieChart>
      </div>
      <hr className={'mb-4'}/>
      <h5>Water stress</h5>
      <p>Does your company use WRI Aqueduct, GEMI, Water Risk Filter, Water Risk Monetizer, or other comparable tool or methodology to determine the water stressed areas in your portfolio?</p>
      <div className="d-flex flex-row w-100 justify-content-center">
        <PieChart
          id="pie"
          type="doughnut"
          palette={palette}
          dataSource={waterData}
          resolveLabelOverlapping={"shift"}
        >
          <PCSeries argumentField="name">
            <Label visible={true}>
              <Connector visible={true} />
            </Label>
          </PCSeries>
          <PCLegend margin={0} horizontalAlignment="center" verticalAlignment="bottom" />
          <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
          </PCTooltip>
        </PieChart>
      </div>
    </div>
    </>
  );
}
